export default {
    getGraph:          state => state.graph,
    getLeadsData:      state => state.data,
    getSelectedParams: state => state.selectedParams,
    getTotalCount:     state => state.totalCount,
};
